import React from 'react'
import { mutualTheme } from '~/utils/theme'
import { Box, Radio, Typography, RadioProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export type RadioButtonProps = {
  label: string,
  selectedOption: any
} & RadioProps

const useStyles = makeStyles({
  container: (props: RadioButtonProps) => ({
    borderWidth: 1,
    display: 'flex',
    borderRadius: 5,
    cursor: 'pointer',
    alignItems: 'center',
    borderStyle: 'solid',
    justifyContent: 'center',
    paddingTop: mutualTheme.spacing(1),
    paddingBottom: mutualTheme.spacing(1),
    paddingLeft: mutualTheme.spacing(2),
    paddingRight: mutualTheme.spacing(2),
    borderColor: mutualTheme.palette.grey[400],
    backgroundColor: props.value === props.selectedOption ? mutualTheme.palette.secondary.main : mutualTheme.palette.textInverse.main,
    [mutualTheme.breakpoints.down('md')]: {
      width: '50px'
    }
  }),
  text: (props: RadioButtonProps) => ({
    color: props.value === props.selectedOption ? mutualTheme.palette.textInverse.main : mutualTheme.palette.textGray2.main
  }),
  radioInput: {
    display: 'none'
  },
  radio: {
    marginLeft: 0
  }
})

export const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const classes = useStyles(props)
  const { selectedOption: _, ...other } = props

  return (
    <Box className={classes.container}>
      <Radio classes={{ root: classes.radio }} className={classes.radioInput} disableRipple {...other} />
      <Typography className={classes.text}>{props.label}</Typography>
    </Box>
  )
}
